export default __webpack_public_path__ + "static/media/NoData2.9bdd778e.svg";